export function StatPill({
  label,
  value,
}: {
  label: string;
  value: string | number;
}) {
  return (
    <div className="glass border border-gray-200 dark:border-white/10 rounded-xl px-4 py-3 flex items-center justify-between">
      <div>
        <p className="text-xs uppercase tracking-wide text-gray-600 dark:text-slate-400">{label}</p>
        <p className="text-lg font-semibold text-gray-900 dark:text-white">{value}</p>
      </div>
      <span className="h-2 w-2 rounded-full bg-primary-500 shadow-[0_0_0_6px] shadow-primary-500/20" />
    </div>
  );
}
